export function navInit() {
  jQuery(document).ready(function ($) {
    //obsługa hamburgera i elementów menu
    "use strict";

    $('.c-hamburger').on('click', function () {
      ($('.header__navBox').hasClass("is-active")) ? $('.header__navBox').removeClass("is-active"): $('.header__navBox').addClass("is-active");
      ($('.c-hamburger').hasClass("is-active")) ? $('.c-hamburger').removeClass("is-active"): $('.c-hamburger').addClass("is-active");
    });

    $('.menu-item a').on('click', function () {
      ($('.header__navBox').hasClass("is-active")) ? $('.header__navBox').removeClass("is-active"): $('.header__navBox').addClass("is-active");
      ($('.c-hamburger').hasClass("is-active")) ? $('.c-hamburger').removeClass("is-active"): $('.c-hamburger').addClass("is-active");
    });
  });

  const headerMenu = document.querySelector('.header__navbar');
  const header = document.querySelector('.header');

  document.addEventListener('scroll', ()=> {
    let offset = window.scrollY;

    // console.log(offset);


    if( offset >= 80 ) {
      header.classList.add('scrolled');
      headerMenu.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
      headerMenu.classList.remove('scrolled');
    }
  })

}